module.exports = __webpack_public_path__ + "static/media/logo-saodomingos.aacc8499.png";